module.exports = __webpack_public_path__ + "assets/img/my-spp-title.7d3a2612.png";